<template>
  <div class="supplier-settle">
    <div class="settle-header">
      <h2>{{ pageTitle }}</h2>
      <p>{{ pageDescription }}</p>
    </div>

    <el-alert
      v-if="applicationState !== null"
      :title="statusText"
      :type="statusAlertType"
      :closable="false"
      show-icon
      class="status-alert"
    />

    <div class="settle-form">
      <el-form
        ref="settleForm"
        :model="formData"
        :rules="rules"
        label-width="120px"
        label-position="left"
      >
        <!-- 企业名称 -->
        <el-form-item label="企业名称" prop="companyName">
          <el-input
            v-model="formData.companyName"
            placeholder="请输入企业名称"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 公司所在地区 -->
        <!-- <el-form-item label="公司所在地区" prop="companyRegions">
          <div class="region-selector">
            <el-select
              v-model="formData.companyProvinceId"
              placeholder="请选择省"
              @change="handleProvinceChange"
              clearable
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-model="formData.companyCityId"
              placeholder="请选择市"
              @change="handleCityChange"
              clearable
              :disabled="!formData.companyProvinceId"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-model="formData.companyDistrictId"
              placeholder="请选择区/县"
              clearable
              :disabled="!formData.companyCityId"
            >
              <el-option
                v-for="item in districtOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </el-form-item> -->

        <!-- 企业详细地址 -->
        <el-form-item label="企业详细地址" prop="companyAddress">
          <el-input
            v-model="formData.companyAddress"
            placeholder="请输入详细地址"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 企业电话 -->
        <el-form-item label="企业电话" prop="companyPhone">
          <el-input
            v-model="formData.companyPhone"
            placeholder="请输入企业电话"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 产品领域 -->
        <el-form-item label="产品领域" prop="productFieldId">
          <el-select
            v-model="formData.productFieldId"
            placeholder="请选择产品领域"
            clearable
            @change="handleProductFieldChange"
            :disabled="isReadonly"
          >
            <el-option
              v-for="item in productFields"
              :key="item.category_id"
              :label="item.category_name"
              :value="item.category_id"
            />
          </el-select>
        </el-form-item>

        <!-- 联系人姓名 -->
        <el-form-item label="联系人姓名" prop="contactName">
          <el-input
            v-model="formData.contactName"
            placeholder="请输入联系人姓名"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 联系人手机 -->
        <el-form-item label="联系人手机" prop="contactPhone">
          <el-input
            v-model="formData.contactPhone"
            placeholder="请输入联系人手机号"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 登录密码 -->
        <el-form-item v-if="!isReadonly" label="登录密码" prop="password">
          <el-input
            v-model="formData.password"
            type="password"
            placeholder="请输入登录密码"
            show-password
            clearable
          />
        </el-form-item>

        <!-- 确认登录密码 -->
        <el-form-item v-if="!isReadonly" label="确认登录密码" prop="confirmPassword">
          <el-input
            v-model="formData.confirmPassword"
            type="password"
            placeholder="请再次输入登录密码"
            show-password
            clearable
          />
        </el-form-item>

        <!-- 服务配置 -->
        <el-form-item label="服务配置" prop="serviceConfig">
          <el-checkbox-group v-model="formData.serviceConfig" :disabled="isReadonly">
            <el-checkbox
              v-for="item in serviceConfigs"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <!-- 统一社会信用码 -->
        <el-form-item label="统一社会信用码" prop="businessLicenceNumber">
          <el-input
            v-model="formData.businessLicenceNumber"
            placeholder="请输入统一社会信用码"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 营业执照电子版 -->
        <el-form-item label="营业执照电子版" prop="businessLicenceElectronic">
          <div class="upload-container">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :data="uploadData"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept="image/*"
              :disabled="isReadonly"
            >
              <div v-if="formData.businessLicenceElectronic" class="upload-preview">
                <img :src="formData.businessLicenceElectronic" alt="营业执照" />
                <div class="upload-actions">
                  <el-button type="text" @click.stop="previewImage">预览</el-button>
                  <el-button v-if="!isReadonly" type="text" @click.stop="removeImage">删除</el-button>
                </div>
              </div>
              <div v-else class="upload-placeholder">
                <i class="el-icon-plus"></i>
                <div class="upload-text">上传营业执照</div>
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <!-- 法定经营范围 -->
        <el-form-item label="法定经营范围" prop="businessSphere">
          <el-input
            v-model="formData.businessSphere"
            type="textarea"
            :rows="4"
            placeholder="请输入法定经营范围"
            maxlength="500"
            show-word-limit
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 税务登记证号 -->
        <el-form-item label="税务登记证号" prop="taxRegistrationCertificate">
          <el-input
            v-model="formData.taxRegistrationCertificate"
            placeholder="请输入税务登记证号"
            clearable
            :disabled="isReadonly"
          />
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item v-if="canSubmit">
          <el-button type="primary" @click="submitForm" :loading="submitting">
            {{ applicationState === -1 || applicationState === -2 ? '重新提交' : '确认提交' }}
          </el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog
      title="营业执照预览"
      :visible.sync="previewVisible"
      width="50%"
      center
    >
      <div class="image-preview">
        <img :src="$img(formData.businessLicenceElectronic)" alt="营业执照" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRegionList } from '@/api/address'
import { getProductDomain, submitShopApply, getShopApplyInfo } from '@/api/shop/settle'
import { getArea } from '@/api/address'
import Config from '@/utils/config'
import { mapGetters } from 'vuex'

export default {
  name: 'SupplierSettle',
  props: {
    inMemberCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 自定义验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.formData.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      submitting: false,
      previewVisible: false,
      applicationState: null,
      
      // 表单数据
      formData: {
        companyName: '', // 企业名称
        companyAddress: '', // 企业详细地址
        companyPhone: '', // 企业电话
        productFieldId: '', // 产品领域ID
        contactName: '', // 联系人姓名
        contactPhone: '', // 联系人手机
        password: '', // 登录密码
        confirmPassword: '', // 确认登录密码
        serviceConfig: [], // 服务配置
        businessLicenceNumber: '', // 统一社会信用码
        businessLicenceElectronic: '', // 营业执照电子版
        businessSphere: '', // 法定经营范围
        taxRegistrationCertificate: '' // 税务登记证号
      },

      // 表单验证规则
      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: '请输入企业详细地址', trigger: 'blur' }
        ],
        companyPhone: [
          { required: true, message: '请输入企业电话', trigger: 'blur' }
        ],
        productFieldId: [
          { required: true, message: '请选择产品领域', trigger: 'change' }
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系人手机', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 8, message: '登录密码至少8位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        businessLicenceNumber: [
          { required: true, message: '请输入统一社会信用码', trigger: 'blur' }
        ],
        businessLicenceElectronic: [
          { required: true, message: '请上传营业执照电子版', trigger: 'change' }
        ],
        businessSphere: [
          { required: true, message: '请输入法定经营范围', trigger: 'blur' }
        ],
        taxRegistrationCertificate: [
          { required: true, message: '请输入税务登记证号', trigger: 'blur' }
        ]
      },

      // 地区选项
      provinceOptions: [], // 省份选项
      cityOptions: [], // 城市选项
      districtOptions: [], // 区县选项

      // 产品领域选项
      productFields: [],

      // 服务配置选项
      serviceConfigs: [
        { label: '七天退货', value: 'shop_qtian' },
        { label: '正品保障', value: 'shop_zhping' },
        { label: '两小时发货', value: 'shop_erxiaoshi' },
        { label: '退货承诺', value: 'shop_tuihuo' },
        { label: '试用中心', value: 'shop_shiyong' },
        { label: '实体验证', value: 'shop_shiti' },
        { label: '消协保证', value: 'shop_xiaoxie' }
      ],

      // 上传配置
      uploadUrl: Config.baseUrl + '/api/upload/shopimg',
      uploadHeaders: {},
      uploadData: {
        path: 'shopimg',
        token: this.$store.getters.token || ''
      }
    }
  },

  async mounted() {
    // 初始化数据
    await this.getProductDomains()
    await this.getProvinces()
    
    // 检查是否需要回填数据（重新申请的情况）
    await this.checkAndFillApplyData()
  },

  computed: {
    ...mapGetters(['member']),
    isReadonly() {
      return this.inMemberCenter && this.applicationState !== null && ![-1, -2].includes(this.applicationState)
    },
    canSubmit() {
      return !this.isReadonly
    },
    statusText() {
      const statusMap = {
        '-2': '审核未通过，请修改资料后重新提交',
        '-1': '审核未通过，请修改资料后重新提交',
        '1': '审核中，提交资料暂不可修改',
        '2': '正在等待财务审核，提交资料暂不可修改',
        '3': '审核通过'
      }
      return statusMap[this.applicationState] || ''
    },
    statusAlertType() {
      if (this.applicationState === 3) return 'success'
      if ([-1, -2].includes(this.applicationState)) return 'error'
      return 'warning'
    },
    pageTitle() {
      return this.isReadonly ? '供应商入驻信息' : this.applicationState === -1 || this.applicationState === -2 ? '供应商重新申请' : '供应商入驻申请'
    },
    pageDescription() {
      if (this.applicationState === 3) return '您的供应商入驻申请已审核通过'
      if (this.applicationState === 1 || this.applicationState === 2) return '您的申请正在审核，请耐心等待审核结果'
      if (this.applicationState === -1 || this.applicationState === -2) return '请修改以下信息后重新提交申请'
      return '请填写以下信息完成供应商入驻申请'
    }
  },

  methods: {
    // 检查并填充申请数据（用于重新申请）
    async checkAndFillApplyData() {
      try {
        const response = await getShopApplyInfo()
        if (response.code === 0 && response.data) {
          this.fillFormData(response.data)
        }
      } catch (error) {
        console.log('获取申请信息失败:', error)
        // 静默处理错误，不影响正常使用
      }
    },

    // 填充表单数据
    async fillFormData(data) {
      const applyData = data.shop_apply || {}
      if (applyData.apply_state !== undefined && applyData.apply_state !== null) {
        this.applicationState = Number(applyData.apply_state)
      }

      // 基本信息映射
      this.formData.companyName = data.site_name || ''
      this.formData.companyAddress = data.address || ''
      this.formData.companyPhone = data.telephone || ''
      this.formData.contactName = data.name || applyData.contacts_name || ''
      this.formData.contactPhone = data.mobile || applyData.contacts_mobile || ''
      
      // 产品领域映射
      if (data.category_name && data.category_id) {
        this.formData.productFieldId = data.category_id
        // 等待产品领域数据加载完成后再设置选中项
        this.$nextTick(() => {
          const fieldIndex = this.productFields.findIndex(field => field.category_id === data.category_id)
          if (fieldIndex !== -1) {
            this.formData.productFieldId = data.category_id
          }
        })
      }
      
      // 服务配置映射
      this.formData.serviceConfig = []
      if (data.shop_qtian == 1) this.formData.serviceConfig.push('shop_qtian')
      if (data.shop_zhping == 1) this.formData.serviceConfig.push('shop_zhping')
      if (data.shop_erxiaoshi == 1) this.formData.serviceConfig.push('shop_erxiaoshi')
      if (data.shop_tuihuo == 1) this.formData.serviceConfig.push('shop_tuihuo')
      if (data.shop_shiyong == 1) this.formData.serviceConfig.push('shop_shiyong')
      if (data.shop_shiti == 1) this.formData.serviceConfig.push('shop_shiti')
      if (data.shop_xiaoxie == 1) this.formData.serviceConfig.push('shop_xiaoxie')
      
      // 如果有申请信息，映射申请相关数据
      if (data.shop_apply) {
        this.formData.businessLicenceNumber = applyData.business_licence_number || ''
        this.formData.businessSphere = applyData.business_sphere || ''
        this.formData.taxRegistrationCertificate = applyData.tax_registration_certificate || ''
        this.formData.businessLicenceElectronic = applyData.business_licence_number_electronic || ''
      }
      
      // 地区信息映射（需要异步处理）
      if (data.province && data.city && data.district) {
        // 先设置省份
        if (data.province) {
          this.formData.province = data.province
          await this.handleProvinceChange(data.province)
        }
        
        // 再设置城市
        if (data.city) {
          this.formData.city = data.city
          await this.handleCityChange(data.city)
        }
        
        // 最后设置区县
        if (data.district) {
          this.formData.district = data.district
        }
      }
    },
      // 获取省份数据
      async getProvinces() {
        try {
          const res = await getArea({ pid: 0 })
          if (res.code === 1 && res.data) {
            this.provinceOptions = res.data
          }
        } catch (error) {
          console.error('获取省份数据失败:', error)
        }
      },

      // 处理省份变化
      async handleProvinceChange(provinceId) {
        this.formData.companyCityId = ''
        this.formData.companyDistrictId = ''
        this.cityOptions = []
        this.districtOptions = []
        
        if (provinceId) {
          try {
            const res = await getArea({ pid: provinceId })
            if (res.code === 1 && res.data) {
              this.cityOptions = res.data
            }
          } catch (error) {
            console.error('获取城市数据失败:', error)
          }
        }
      },

      // 处理城市变化
      async handleCityChange(cityId) {
        this.formData.companyDistrictId = ''
        this.districtOptions = []
        
        if (cityId) {
          try {
            const res = await getArea({ pid: cityId })
            if (res.code === 1 && res.data) {
              this.districtOptions = res.data
            }
          } catch (error) {
            console.error('获取区县数据失败:', error)
          }
        }
      },
    // 获取产品领域数据
    async getProductDomains() {
      try {
        const res = await getProductDomain()
        if (res.code === 0 && res.data) {
          this.productFields = res.data
        }
      } catch (error) {
        console.error('获取产品领域失败:', error)
        this.$message.error('获取产品领域失败')
      }
    },

    // 产品领域选择处理
    handleProductFieldChange(value) {
      const selectedField = this.productFields.find(item => item.category_id === value)
      if (selectedField) {
        console.log('选择的产品领域:', selectedField.category_name)
      }
    },

    // 上传前验证
    beforeUpload(file) {
      const isImage = file.type.indexOf('image/') === 0
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        return false
      }
      
      // 更新上传时的token，确保认证信息是最新的
      this.uploadData.token = this.$store.getters.token || ''
      
      return true
    },

    // 上传成功处理
    handleUploadSuccess(response) {
      console.log('上传响应:', response)
      // 根据实际接口返回判断成功状态
      if (response.code === 1 || response.code === 0 || response.code === 10069) {
        // 兼容不同的响应格式
        const imagePath = response.data?.pic_path || response.data?.url || response.data
        this.formData.businessLicenceElectronic = imagePath
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        // 手动触发表单验证
        this.$refs.settleForm.validateField('businessLicenceElectronic')
      } else {
        this.$message.error(response.message || response.msg || '上传失败')
      }
    },

    // 上传失败处理
    handleUploadError(error) {
      console.error('上传失败:', error)
      this.$message.error('上传失败，请重试')
    },

    // 预览图片
    previewImage() {
      if (this.formData.businessLicenceElectronic) {
        window.open(this.formData.businessLicenceElectronic)
      }
    },

    // 删除图片
      removeImage() {
        this.formData.businessLicenceElectronic = ''
        // 手动触发表单验证
        this.$refs.settleForm.validateField('businessLicenceElectronic')
      },

    // 提交表单
    submitForm() {
      this.$refs.settleForm.validate((valid) => {
        if (valid) {
          this.$confirm('信息已填写完毕，确定提交？', '确认提交', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doSubmit()
          })
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },

    // 执行提交
    async doSubmit() {
      this.submitting = true
      
      try {
        // 构建提交数据
        const submitData = {
          company_name: this.formData.companyName,
          category_id: this.formData.productFieldId,
          contacts_mobile: this.formData.contactPhone,
          company_address: this.formData.companyAddress,
          
          // 服务配置转换为独立字段
          shop_qtian: this.formData.serviceConfig.includes('shop_qtian') ? 1 : 0,
          shop_zhping: this.formData.serviceConfig.includes('shop_zhping') ? 1 : 0,
          shop_erxiaoshi: this.formData.serviceConfig.includes('shop_erxiaoshi') ? 1 : 0,
          shop_tuihuo: this.formData.serviceConfig.includes('shop_tuihuo') ? 1 : 0,
          shop_shiyong: this.formData.serviceConfig.includes('shop_shiyong') ? 1 : 0,
          shop_shiti: this.formData.serviceConfig.includes('shop_shiti') ? 1 : 0,
          shop_xiaoxie: this.formData.serviceConfig.includes('shop_xiaoxie') ? 1 : 0,
          
          cert_type: 2, // 企业店铺
          
          // 公司信息
          company_province_id: this.formData.companyProvinceId,
          company_city_id: this.formData.companyCityId,
          company_district_id: this.formData.companyDistrictId,
          
          contacts_name: this.formData.contactName,
          password: this.formData.password,
          
          // 营业执照信息
          business_licence_number: this.formData.businessLicenceNumber,
          business_licence_number_electronic: this.formData.businessLicenceElectronic,
          business_sphere: this.formData.businessSphere,
          tax_registration_certificate: this.formData.taxRegistrationCertificate
        }

        const res = await submitShopApply(submitData)

        if (res.code === 0) {
          this.$message.success('提交成功，请等待审核')
          
          // 更新用户信息
          this.updateUserInfo()
          
          // 提交成功后进入会员中心回显申请状态和资料
          setTimeout(() => {
            this.$router.push('/member/settle?tab=supplier')
          }, 1500)
        } else {
          this.$message.error(res.message || '提交失败')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error(error.message || '提交失败')
      } finally {
        this.submitting = false
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.settleForm.resetFields()
      this.formData = {
        companyName: '',
        companyProvinceId: '',
        companyCityId: '',
        companyDistrictId: '',
        companyAddress: '',
        companyPhone: '',
        productFieldId: '',
        contactName: '',
        contactPhone: '',
        password: '',
        confirmPassword: '',
        serviceConfig: [],
        businessLicenceNumber: '',
        businessLicenceElectronic: '',
        businessSphere: '',
        taxRegistrationCertificate: ''
      }
      this.cityOptions = []
      this.districtOptions = []
    },
    
    // 更新用户信息
    async updateUserInfo() {
      try {
        await this.$store.dispatch('member/member_detail', { refresh: 1 })
      } catch (error) {
        console.error('更新用户信息失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.supplier-settle {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .settle-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;

    h2 {
      color: #303133;
      font-size: 24px;
      margin-bottom: 10px;
    }

    p {
      color: #909399;
      font-size: 14px;
    }
  }

  .status-alert {
    max-width: 800px;
    margin: 0 auto 20px;
  }

  .settle-form {
    max-width: 800px;
    margin: 0 auto;

    .el-form-item {
      margin-bottom: 22px;
    }

    .upload-container {
      .upload-demo {
        .upload-preview {
          position: relative;
          width: 200px;
          height: 200px;
          border: 1px solid #dcdfe6;
          border-radius: 6px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .upload-actions {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.7);
            padding: 8px;
            text-align: center;

            .el-button {
              margin: 0 5px;
            }
          }
        }

        .upload-placeholder {
          width: 200px;
          height: 200px;
          border: 2px dashed #d9d9d9;
          border-radius: 6px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: border-color 0.3s;

          &:hover {
            border-color: #409eff;
          }

          .el-icon-plus {
            font-size: 28px;
            color: #8c939d;
            margin-bottom: 10px;
          }

          .upload-text {
            color: #8c939d;
            font-size: 14px;
          }
        }
      }
    }
  }

  .image-preview {
    text-align: center;

    img {
      max-width: 100%;
      max-height: 500px;
    }
  }
}

// 响应式适配
@media (max-width: 768px) {
  .supplier-settle {
    padding: 15px;

    .settle-form {
      .el-form {
        ::v-deep .el-form-item__label {
          width: 100px !important;
        }
      }

      .upload-container {
        .upload-demo {
          .upload-preview,
          .upload-placeholder {
            width: 150px;
            height: 150px;
          }
        }
      }
    }
  }

  .region-selector {
    display: flex;
    gap: 10px;
    
    .el-select {
      flex: 1;
    }
  }
}
</style>
